export enum StatusCodes {
    OK = 'OK',
    KO = 'KO'
}

export enum ProfiloClinicoGenericListTypes {
    FATTORI_RISCHIO = 'SD_INT_1',
    MALATTIE_CARDIOVASCOLARI = 'SD_INT_2',
    MALATTIE_CONCOMITANTI = 'SD_INT_3',
}